import { useQuery as a } from "@tanstack/vue-query";
import { computed as u, toValue as i } from "vue";
const c = ["statistics"], m = 5, p = 60, l = 1e3, y = m * p * l, n = {
  all: c,
  domains: (s) => [...c, "domains", s],
  spots: (s) => [...c, "spots", s],
  spotsTop: (s) => [...c, "spots-top", s],
  domainsBySpot: (s) => [...c, "domains-by-spot", s],
  childCounts: (s) => [...c, "child-counts", s],
  totals: (s) => [...c, "totals", s],
  campaignTimeseries: (s) => [...c, "campaign-timeseries", s],
  metrics: (s) => [...c, "metrics", s],
  campaignRollup: (s) => [...c, "campaign-rollup", s],
  reports: () => [...c, "reports"],
  reportDimensions: (s) => [...c, "report-dimensions", s],
  reportMetrics: (s) => [...c, "report-metrics", s],
  reportGrouped: (s) => [...c, "report-grouped", s],
  reportValues: (s) => [...c, "report-values", s],
  query: (s) => [...c, "query", s],
  segments: () => [...c, "segments"]
}, T = (s, t, e) => {
  const r = u(() => n.domains(i(t)));
  return a({
    staleTime: y,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: o }) => s.statistics.domains(i(t), { signal: o })
  });
}, d = (s, t, e) => {
  const r = u(() => n.spots(i(t)));
  return a({
    staleTime: y,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: o }) => s.statistics.spots(i(t), { signal: o })
  });
}, K = ({
  queryClient: s,
  client: t,
  input: e,
  meta: r
}) => s.fetchQuery({
  queryKey: n.spots(e),
  queryFn: ({ signal: o }) => t.statistics.spots(e, { signal: o }),
  staleTime: 0,
  ...r && { meta: r }
}), g = (s, t, e) => {
  const r = u(() => n.campaignTimeseries(i(t)));
  return a({
    staleTime: y,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: o }) => s.statistics.campaignTimeseries(i(t), { signal: o })
  });
}, F = (s, t, e) => {
  const r = u(() => n.metrics(i(t)));
  return a({
    staleTime: y,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: o }) => s.statistics.metrics(i(t), { signal: o })
  });
}, I = (s, t, e) => {
  const r = u(() => n.campaignRollup(i(t)));
  return a({
    ...e,
    queryKey: r,
    queryFn: async ({ signal: o }) => s.statistics.campaignRollup(i(t), { signal: o })
  });
}, C = (s, t, e) => {
  const r = u(() => n.totals(i(t)));
  return a({
    staleTime: y,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: o }) => s.statistics.totals(i(t), { signal: o })
  });
}, E = (s, t, e) => {
  const r = u(() => n.spotsTop(i(t)));
  return a({
    staleTime: y,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: o }) => s.statistics.spotsTop(i(t), { signal: o })
  });
}, M = ({
  queryClient: s,
  client: t,
  input: e,
  meta: r
}) => s.fetchQuery({
  queryKey: n.domainsBySpot(e),
  queryFn: ({ signal: o }) => t.statistics.domainsBySpot(e, { signal: o }),
  staleTime: 0,
  ...r && { meta: r }
}), h = (s, t, e) => {
  const r = u(() => n.childCounts(i(t)));
  return a({
    staleTime: y,
    ...e,
    queryKey: r,
    queryFn: async ({ signal: o }) => s.statistics.childCounts(i(t), { signal: o })
  });
}, D = (s, t) => a({
  staleTime: y,
  ...t,
  queryKey: n.reports(),
  queryFn: async ({ signal: e }) => s.statistics.reports(void 0, { signal: e })
}), R = (s, t, e) => a({
  staleTime: y,
  ...e,
  queryKey: u(() => n.reportDimensions(i(t))),
  queryFn: async ({ signal: r }) => s.statistics.reportDimensions(i(t), { signal: r })
}), _ = (s, t, e) => a({
  staleTime: y,
  ...e,
  queryKey: u(() => n.reportMetrics(i(t))),
  queryFn: async ({ signal: r }) => s.statistics.reportMetrics(i(t), { signal: r })
}), f = (s, t, e) => a({
  ...e,
  queryKey: u(() => n.reportGrouped(i(t))),
  queryFn: async ({ signal: r }) => s.statistics.reportGrouped(i(t), { signal: r })
}), N = (s, t, e) => a({
  ...e,
  queryKey: u(() => n.reportValues(i(t))),
  queryFn: async ({ signal: r }) => s.statistics.reportValues(i(t), { signal: r })
}), A = (s, t, e) => a({
  staleTime: 1 / 0,
  ...e,
  queryKey: u(() => n.query(i(t))),
  queryFn: async ({ signal: r }) => s.statistics.getQuery(i(t), { signal: r })
}), B = (s, t) => a({
  staleTime: y,
  ...t,
  queryKey: n.segments(),
  queryFn: async ({ signal: e }) => s.statistics.segments(void 0, { signal: e })
});
export {
  M as fetchDomainsBySpotStatistics,
  K as fetchSpotStatistics,
  n as statisticsKeys,
  I as useCampaignRollup,
  g as useCampaignTimeseries,
  h as useChildCounts,
  T as useDomainStatistics,
  d as useSpotStatistics,
  F as useStatisticsMetrics,
  R as useStatisticsReportDimensions,
  f as useStatisticsReportGrouped,
  _ as useStatisticsReportMetrics,
  N as useStatisticsReportValues,
  D as useStatisticsReports,
  A as useStatisticsSavedQuery,
  B as useStatisticsSegments,
  E as useTopSpotStatistics,
  C as useTotalStatistics
};
//# sourceMappingURL=queries.js.map
